import processJSON from "@/lib/processJSON";

const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_JOURNAL_LPO = ROOT_API + "get_journal_lpo.php";
const CREATE_LEASE = ROOT_API + "create_lease.php";

import store from "@/store";
import address from "./address";

export default {
  namespaced: true,

  modules: {
    address,
  },

  state: {
    multipleMode: false,
    multipleList: [],

    existingLpo: null,
  },
  mutations: {
    setMultipleMode(state, payload) {
      state.multipleMode = payload;
    },

    addAddressToMultipleList(state, address) {
      state.multipleList.push(address);
    },
    removeAddressFromMultipleList(state, address_index) {
      state.multipleList.splice(address_index, 1);
    },

    setExistingLpo(state, lpo) {
      state.existingLpo = lpo;
    },
  },
  actions: {
    addAddressToMultipleList(context, payload) {
      const { state, commit } = context;

      const address = {
        fo: state.address.selectedFo.name,
        region: state.address.selectedRegion.name,
        forestry: state.address.selectedForestry.name,
        localforestry: state.address.selectedLocalforestry.name,
        subforestry: state.address.selectedSubforestry.name,
        area: state.address.selectedArea.name,
        section: state.address.selectedSection.name,
        section_lp: state.address.selectedSectionLp,

        localforestry_id: state.address.selectedLocalforestry.id,
        locality_id: state.address.selectedFo.id,
        tax_id: state.address.selectedSection.id,
		inspection_type_id: state.address.selectedInspectionType ? state.address.selectedInspectionType.id: null
      };

      commit("addAddressToMultipleList", address);

      if (state.address.sectionLpExists) {
        if (!isNaN(state.address.selectedSectionLp)) {
          const number = Number(state.address.selectedSectionLp) + 1;
          const string = String(number);
          commit("createLpo/address/setSelectedSectionLp", string, {
            root: true,
          });
        }
      }

      // console.log(JSON.stringify(address, null, 2));
    },

    removeAddressFromMultipleList(state, address_index) {
      const { commit } = state;
      commit("removeAddressFromMultipleList", address_index);
    },

    createLpo(context, payload) {
      const { state, dispatch } = context;

      if (state.multipleMode) {
        return dispatch("_createLpoMultiple");
      } else {
        return dispatch("_createLpoSingle");
      }
    },

    _createLpoSingle(context, payload) {
      const { state, rootState, dispatch } = context;

      const json_obj = [
        {
          i: {
            tab: [
              {
                tab_name: "data_lpo",
                f_v: {
                  tax_id: state.address.selectedSection.id,
                  section_lp: state.address.selectedSectionLp,
                  user_id: store.state.auth.userId,
                  engineer_id: store.state.auth.userId,
				          inspection_type_id: state.address.selectedInspectionType ? state.address.selectedInspectionType.id: null
                },
              },
            ],
          },
        },
      ];
      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str)
        .then((res) => {
          return dispatch("_getCreatedLpoSingle");
        })
        .then((res) => {
          if (!res.length) {
            throw new Error(
              "Error _getCreatedLpoSingle: Не удалось получить созданное обследование"
            );
          }
          const lpo = res[0];
          return dispatch("_createLeaseSingle", lpo).then((res) => {
            return lpo.lpo_id;
          });
        })
        .catch((err) => {
          throw err;
        });
    },

    _getCreatedLpoSingle(context, payload) {
      const { state, rootState } = context;

      const section = state.address.selectedSection;
      const section_lp = state.address.selectedSectionLp;

      let temp = "";
      if (section_lp === null) {
        temp = `(tax_id=''${section.id}'' and (section_lp is null))`;
      } else {
        temp = `(tax_id=''${section.id}'' and section_lp=''${section_lp}'')`;
      }

      const filter = temp;

      const form = new FormData();
      form.append("current_page", 1);
      form.append("per_page", 1);
      form.append("filter", filter);
      form.append("user_id", rootState.auth.userId);

      return fetch(GET_JOURNAL_LPO, {
        credentials: "include",
        method: "post",
        body: form,
      }).then((res) => res.json());
    },
    _createLeaseSingle(context, lpo) {
      const form = new FormData();

      form.append("lpo_list_str", "'" + lpo.lpo_id + "'");

      return fetch(CREATE_LEASE, {
        credentials: "include",
        method: "post",
        body: form,
      }).then((res) => res.json());
    },

    _createLpoMultiple(context, payload) {
      const { state, rootState, dispatch } = context;

      const insertSection = [];
      for (const lpo of state.multipleList) {
        const temp = {
          tab_name: "data_lpo",
          f_v: {
            tax_id: lpo.tax_id,
            section_lp: lpo.section_lp,
            user_id: rootState.auth.userId,
            engineer_id: rootState.auth.userId,
			inspection_type_id: lpo.inspection_type_id,
          },
        };
        insertSection.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: insertSection,
          },
        },
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      return processJSON(json_str)
        .then((res) => {
          return dispatch("_getCreatedLpoMultiple");
        })
        .then((lpoList) => {
          if (lpoList.length !== state.multipleList.length) {
            throw new Error(
              "Error _getCreatedLpoMultiple: Не удалось получить созданные обследование"
            );
          }
          return lpoList;
        })
        .then((lpoList) => {
          dispatch("_createLeaseMultiple", lpoList).catch((err) => {
            throw err;
          });
          return lpoList[0].lpo_id;
        })
        .catch((err) => {
          throw err;
        });
    },

    _getCreatedLpoMultiple(context, payload) {
      const { state, rootState } = context;

      const filter_arr = [];
      for (const lpo of state.multipleList) {
        let temp = "";
        if (lpo.section_lp === null) {
          temp = `(tax_id=''${lpo.tax_id}'' and (section_lp is null))`;
        } else {
          temp = `(tax_id=''${lpo.tax_id}'' and section_lp=''${lpo.section_lp}'')`;
        }

        filter_arr.push(temp);
      }
      const filter = filter_arr.join(" or ");

      const form = new FormData();
      form.append("current_page", 1);
      form.append("per_page", state.multipleList.length);
      form.append("filter", filter);
      form.append("user_id", rootState.auth.userId);

      return fetch(GET_JOURNAL_LPO, {
        credentials: "include",
        method: "post",
        body: form,
      }).then((res) => res.json());
    },

    _createLeaseMultiple(context, lpoList) {
      const lpoListStr = lpoList.map((lpo) => "'" + lpo.lpo_id + "'").join(",");

      const form = new FormData();
      form.append("lpo_list_str", lpoListStr);

      return fetch(CREATE_LEASE, {
        credentials: "include",
        method: "post",
        body: form,
      }).then((res) => res.json());
    },

    /* EXISTING LPO */
    getExistingLpo(context, payload) {
      const { state, rootState, commit } = context;

      const section = state.address.selectedSection;
      const section_lp = state.address.selectedSectionLp;

      let temp = "";
      if (section_lp === null) {
        temp = `(tax_id=''${section.id}'' and (section_lp is null))`;
      } else {
        temp = `(tax_id=''${section.id}'' and section_lp=''${section_lp}'')`;
      }

      const filter = temp;

      const form = new FormData();
      form.append("current_page", 1);
      form.append("per_page", 1);
      form.append("filter", filter);
      form.append("user_id", rootState.auth.userId);

      return fetch(GET_JOURNAL_LPO, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          if (!res.length) {
            throw new Error("ERROR: getExistingLpo");
          }
          commit("setExistingLpo", res[0]);
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
